import { PUT_COOKIES } from './action';

function cookiesReducer(state=null, action)
{
    switch (action.type) {
      case PUT_COOKIES: 
        return action.payload;

      default:
        return state;
  }
}

export default cookiesReducer;
